
import { Field, Form } from "react-final-form";
import { ICallRecordingsSearchFormProps } from "../../interfaces/search-form";
import DateFnsUtils from "@date-io/date-fns";
import GetExtensionOptionsForCallRecordingSearch from "./GetExtensionOptionsForCallRecordingSearch";
import { Button, Grid, ButtonGroup } from "@material-ui/core";
import { KeyboardDatePicker, KeyboardDateTimePicker, KeyboardTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MuiSelect from "../../components/MuiComponents/MuiSelect";
import MuiTextInput from "../../components/MuiComponents/MuiTextInput";
import React from "react";

const hours:string[] = []
for(let i=0;i<24;i++){
  let hourString=i+''
  if(i<10){
    hourString='0'+i
  }
  hours.push(hourString)
}

const minutes:string[] = []
for(let i=0;i<60;i=i+5){
  let minutesString=i+''
  if(i<10){
    minutesString='0'+i
  }
  minutes.push(minutesString)
}

const CallRecordingSearchForm: React.FunctionComponent<
  ICallRecordingsSearchFormProps
> = ({ services, onSubmit, data, resellerId }) => {
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={data}
      render={({ handleSubmit, form, submitting, pristine, values }) => (<MuiPickersUtilsProvider utils={DateFnsUtils}>
        <form onSubmit={handleSubmit}>

          <Grid
            container
            spacing={2}
          >

            <Grid item xs={3} >
            </Grid>

            <Grid item xs={3} style={{ textAlign: 'center' }}>From</Grid>

            <Grid item xs={3} style={{ textAlign: 'center' }}>To</Grid>

            <Grid item xs={3} >
            </Grid>
            <Grid item xs={3} >
              {(services || onSubmit || data || resellerId) !== undefined &&
                services.length > 1 && (<MuiSelect
                    name="customersSitesServicesId"
                    label="Site"
                    options={services!.map((service) => {
                      return { value: service.id, label: service.siteName };
                    })}
                  />
                )}
            </Grid>

            <Grid item xs={3}>
              <Field name="datetime.$gte">
                    {({ input: { onChange, value } }) => (
                      <KeyboardDatePicker
                        variant="inline"
                        format="dd/MM/yyyy"
                        margin="normal"
                        id="date-picker-inline"
                        value={value}
                        onChange={onChange}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                    )}
                  </Field>
            </Grid>
                  
            <Grid item xs={3} >
              <Field name="datetime.$lte">
                {({ input: { onChange, value } }) => (
                  <KeyboardDatePicker
                    variant="inline"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    value={value}
                    onChange={onChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                )}
              </Field>
            </Grid>

            <Grid item xs={3}>
              <MuiTextInput outlinedLabel="Source" name="source" />
            </Grid>

            <Grid item xs={3}></Grid>

            <Grid item xs={3}>
              <Grid container>
                <Grid item xs={6}>
                  <MuiSelect
                    name="fromHours"
                    label="Hours"
                    options={hours.map((hour) => {
                      return { value: hour, label: hour };
                    })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <MuiSelect
                    name="fromMinutes"
                    label="Minutes"
                    options={minutes.map((minute) => {
                      return { value: minute, label: minute };
                    })}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={3}>
              <Grid container>
                <Grid item xs={6}>
                  <MuiSelect
                    name="toHours"
                    label="Hours"
                    options={hours.map((hour) => {
                      return { value: hour, label: hour };
                    })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <MuiSelect
                    name="toMinutes"
                    label="Minutes"
                    options={minutes.map((minute) => {
                      return { value: minute, label: minute };
                    })}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={3}></Grid>

            <Grid item xs={3}>
              <MuiTextInput outlinedLabel="Destination" name="destination" />
            </Grid>
            
            <Grid item xs={3}>
              <MuiTextInput outlinedLabel="DDI" name="ddi" />
            </Grid>

            <Grid item xs={3}
              style={{ maxWidth: "346px", marginBottom: "16px" }}>

              <GetExtensionOptionsForCallRecordingSearch name="extensionName" resellerId={resellerId}
                customersSitesServicesId={values.customersSitesServicesId}
                label="Agent" />

            </Grid>

            <Grid item xs={3}>
              <ButtonGroup fullWidth>
                <Button

                  id="CallLogSearchBtn"
                  variant="contained"
                  color="primary"
                  fullWidth
                  type="submit"
                >
                  Search
                </Button>


                {resellerId && (
                  <Button href={`/voip/portal/reseller/${resellerId}/service/${values.customersSitesServicesId}/callrec`} variant="contained"
                    color="secondary">
                    Settings
                  </Button>
                )}</ButtonGroup>
            </Grid>


          </Grid>


          {/* {JSON.stringify(values)} */}

        </form> </MuiPickersUtilsProvider>
      )}
    />
  );
};

export default CallRecordingSearchForm;
